import cacheKeys from '@/data/api/cacheKeys';
import { getBuyers } from '@/data/api/request/buyersRequests';
import { useQuery } from '@tanstack/react-query';

export function useGetBuyers(page: number) {
  const { data, error, isLoading } = useQuery({
    queryKey: [cacheKeys.buyer.list, { page }],
    queryFn: () => getBuyers({ pageNumber: page }),
  });

  return {
    data,
    error,
    isLoading,
  };
}
